export const selectedMode = (predicate)=>{
    if (predicate.in != null && predicate.in.includes('specificDate')) return 'specificDate';
    if (predicate.nin != null && predicate.nin.includes('onAcceptance')) return 'specificDate';
    return 'onAcceptance';
};
export const localizeMode = (mode, t)=>mode === 'specificDate' ? t.effectiveDateModeSpecificDate() : t.effectiveDateModeOnAcceptance();
export const togglePredicate = (predicate)=>{
    const next = selectedMode(predicate) === 'specificDate' ? 'onAcceptance' : 'specificDate';
    return {
        in: [
            next
        ]
    };
};
